export default {"src":"/_next/static/media/bosnia-and-herzegovina.5e82e08c.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};